import JSZip from "jszip";

interface FilenameElements {
  codigo: string;
  tipoinmueble?: string;
}

const LOCAL_ZIP_ENDPOINT = "/api/zip-imagenes";

async function clientSideZipFallback(imageUrls: string[], codigo: string): Promise<boolean> {
  console.log(`[imageDownloader] Ejecutando descarga cliente fallback para ${imageUrls.length} imágenes...`);
  try {
    const zip = new JSZip();
    const folder = zip.folder(codigo) || zip;
    let downloadedCount = 0;

    for (let i = 0; i < imageUrls.length; i++) {
      const rawUrl = typeof imageUrls[i] === "object" ? (imageUrls[i] as any)?.url : String(imageUrls[i] || "");
      if (!rawUrl || typeof rawUrl !== "string" || !rawUrl.startsWith("http")) continue;

      try {
        const proxyUrl = `/api/image-proxy?url=${encodeURIComponent(rawUrl)}`;
        const res = await fetch(proxyUrl);
        if (res.ok) {
          const blob = await res.blob();
          const extMatch = rawUrl.match(/\.(png|jpg|jpeg|webp|gif)(\?.*)?$/i);
          const ext = extMatch ? extMatch[1].toLowerCase() : "jpg";
          folder.file(`${codigo}-${i + 1}.${ext}`, blob);
          downloadedCount++;
        }
      } catch (e) {
        console.warn(`[imageDownloader] Fallback cliente no pudo obtener imagen ${i + 1}:`, e);
      }
    }

    if (downloadedCount === 0) {
      alert("No fue posible descargar las imágenes de este inmueble.");
      return false;
    }

    const zipContent = await zip.generateAsync({ type: "blob" });
    const url = URL.createObjectURL(zipContent);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${codigo}.zip`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    return true;
  } catch (err) {
    console.error("[imageDownloader] Error en fallback de descarga cliente:", err);
    alert("Ocurrió un error al generar la descarga de imágenes.");
    return false;
  }
}

export const downloadAllPropertyImages = async (
  imageUrls: string[],
  baseFilenameElements: FilenameElements
): Promise<boolean> => {
  if (!imageUrls || imageUrls.length === 0) {
    console.warn("No se proporcionaron imágenes para descargar.");
    return false;
  }

  const codigo = (baseFilenameElements?.codigo || "inmueble").trim().replace(/[/\\?%*:|"<>]/g, "-");

  try {
    const response = await fetch(LOCAL_ZIP_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        codigo,
        urls: imageUrls
      })
    });

    if (!response.ok) {
      let errorMsg = `Status ${response.status}`;
      try {
        const errJson = await response.json();
        if (errJson?.error) errorMsg = errJson.error;
      } catch {
        const errText = await response.text();
        if (errText) errorMsg = errText;
      }

      console.warn(`[imageDownloader] Servidor retornó error (${response.status}): ${errorMsg}. Activando fallback cliente...`);
      return await clientSideZipFallback(imageUrls, codigo);
    }

    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = `${codigo}.zip`;

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.warn("[imageDownloader] Error en la llamada al servidor de ZIP. Ejecutando fallback cliente...", error);
    return await clientSideZipFallback(imageUrls, codigo);
  }
};

